export default "__VITE_ASSET__CJX5g23K__"